import React from "react";
import { Link, useNavigate } from "react-router-dom";
// import { useDispatch } from 'react-redux';
// import { register, logout,login } from '../actions/auth';

import logo from "./../assets/logo-text.png";
import { connect } from "react-redux";

import { logout } from "../actions/auth";

const Header = ({ logout, auth: { isAuthenticated } }) => {
  const navigate = useNavigate();

  return (
    <header>
      <div className="header-area header-transparent">
        <div className="main-header header-sticky">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xl-2 col-lg-2">
                <div className="logo">
                  <Link
                    to="/"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      textDecoration: "none",
                      color: "white",
                    }}
                  >
                    <img src={logo} className="logo" alt="Logo" />
                  </Link>
                </div>
              </div>
              <div className="col-xl-10 col-lg-10">
                <div className="main-menu f-right d-none d-lg-block">
                  <nav>
                    <ul id="navigation">
                      <li>
                        <Link style={{ textDecoration: "none" }} to="/">
                          Home
                        </Link>
                      </li>
                      <li>
                        <Link style={{ textDecoration: "none" }} to="/modules">
                          Modules
                        </Link>
                      </li>
                      <li>
                        <Link style={{ textDecoration: "none" }} to="/schedule">
                          Schedule
                        </Link>
                      </li>
                      <li>
                        <Link style={{ textDecoration: "none" }} to="/location">
                          Location
                        </Link>
                      </li>
                      {/* <li>
                        <Link style={{ textDecoration: "none" }} to="/about">
                          About
                        </Link>
                      </li> */}
                      <li>
                        <Link style={{ textDecoration: "none" }} to="/contact">
                          Contact
                        </Link>
                      </li>
                      <li>
                        <div className="header-right-btn f-right ml-15 d-none d-xl-inline-block">
                          {isAuthenticated ? (
                            <>
                              <button
                                onClick={() => {
                                  navigate("/dashboard");
                                }}
                                style={{ textDecoration: "none" }}
                                className="header-btn"
                              >
                                Dashboard<i className="ti-arrow-right"></i>
                              </button>
                            </>
                          ) : (
                            <Link
                              style={{ textDecoration: "none" }}
                              to="/register"
                              className="header-btn"
                            >
                              Register<i className="ti-arrow-right"></i>
                            </Link>
                          )}
                        </div>
                      </li>
                      {isAuthenticated && (
                        <li>
                          <Link
                            onClick={() => {
                              logout();
                              navigate("/login");
                            }}
                            style={{ textDecoration: "none" }}
                          >
                            Logout
                          </Link>
                        </li>
                      )}
                    </ul>
                  </nav>
                </div>
              </div>

              <div className="col-12">
                <div className="mobile_menu d-block d-lg-none">
                  <div className="slicknav_menu">
                    <p
                      style={{ position: "absolute", right: 20 }}
                      className="slicknav_btn slicknav_collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      <span className="slicknav_menutxt">MENU</span>
                      <span className="slicknav_icon">
                        <span className="slicknav_icon-bar"></span>
                        <span className="slicknav_icon-bar"></span>
                        <span className="slicknav_icon-bar"></span>
                      </span>
                    </p>
                    <br />
                    <br />
                    <div id="accordionExample">
                      <div className="accordion-item">
                        <div
                          id="collapseOne"
                          className="accordion-collapse collapse "
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body ">
                            <ul
                              className="slicknav_nav slicknav_hidden"
                              aria-hidden="true"
                              role="menu"
                            >
                              <li>
                                <Link
                                  style={{ textDecoration: "none" }}
                                  to="/"
                                  role="menuitem"
                                  tabIndex="-1"
                                >
                                  Home
                                </Link>
                              </li>
                              <li>
                                <Link
                                  style={{ textDecoration: "none" }}
                                  to="/modules"
                                  role="menuitem"
                                  tabIndex="-1"
                                >
                                  Modules
                                </Link>
                              </li>
                              <li>
                                <Link
                                  style={{ textDecoration: "none" }}
                                  to="/schedule"
                                  role="menuitem"
                                  tabIndex="-1"
                                >
                                  Schedule
                                </Link>
                              </li>
                              <li>
                                <Link
                                  style={{ textDecoration: "none" }}
                                  to="/location"
                                  role="menuitem"
                                  tabIndex="-1"
                                >
                                  Location
                                </Link>
                              </li>
                              {/* <li>
                                <Link
                                  style={{ textDecoration: "none" }}
                                  to="/about"
                                  role="menuitem"
                                  tabIndex="-1"
                                >
                                  About
                                </Link>
                              </li> */}

                              <li>
                                <Link
                                  style={{ textDecoration: "none" }}
                                  to="/contact"
                                  role="menuitem"
                                  tabIndex="-1"
                                >
                                  Contact
                                </Link>
                              </li>
                              <li>
                                <div className="header-right-btn f-right ml-15 d-none d-xl-inline-block">
                                  <Link
                                    style={{ textDecoration: "none" }}
                                    to="/register"
                                    className="header-btn"
                                    tabIndex="-1"
                                  >
                                    Confirm Your Seat
                                    <i className="ti-arrow-right"></i>
                                  </Link>
                                </div>
                              </li>
                            </ul>
                            <br />
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <Link
                      to={"/"}
                      aria-haspopup="true"
                      role="button"
                      tabIndex="0"
                      className="slicknav_btn slicknav_collapsed"
                    >
                      <span className="slicknav_menutxt">MENU</span>
                      <span className="slicknav_icon">
                        <span className="slicknav_icon-bar"></span>
                        <span className="slicknav_icon-bar"></span>
                        <span className="slicknav_icon-bar"></span>
                      </span>
                    </Link> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logout })(Header);
